// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const InvoicesPage = lazy(() => import('./pages/InvoicesPage'));
const InvoiceTemplatesPage = lazy(() => import('./pages/InvoiceTemplatesPage'));
const PaymentsPage = lazy(() => import('./pages/PaymentsPage'));
const ArAgingPage = lazy(() => import('./pages/ArAgingPage'));

export const InvoicingRoutes: RouteObject = {
  path: 'invoicing',
  element: <ModuleGuard moduleId="finance.invoicing" />,
  children: [
    { path: 'invoices', element: <InvoicesPage />, handle: { crumb: 'Invoices' } },
    { path: 'invoice-templates', element: <InvoiceTemplatesPage />, handle: { crumb: 'Invoice Templates' } },
    { path: 'payments', element: <PaymentsPage />, handle: { crumb: 'Payments' } },
    { path: 'ar-aging', element: <ArAgingPage />, handle: { crumb: 'AR Aging' } },
  ],
};
